import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getAnnouncementByGuid, getActiveAnnouncements } from '../../api/announcementService';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

const AnnouncementDetail = () => {
  const { urlTag } = useParams();
  const location = useLocation();
  const guidFromState = location.state?.guid;
  const [announcement, setAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAnnouncementDetail = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      let guid = guidFromState;

      // Eğer state'den guid gelmemişse (direkt URL girişi), urlTag ile bul
      if (!guid && urlTag) {
        console.log('GUID not found in state, fetching by urlTag:', urlTag);
        const allAnnouncementsResponse = await getActiveAnnouncements(1, 1000);
        
        if (allAnnouncementsResponse.isSuccess && allAnnouncementsResponse.data?.items) {
          const foundAnnouncement = allAnnouncementsResponse.data.items.find(
            item => item.urlTag === urlTag
          );
          
          if (foundAnnouncement) {
            guid = foundAnnouncement.guid;
            console.log('Found announcement with guid:', guid);
          } else {
            console.log('Announcement not found with urlTag:', urlTag);
            setError('Duyuru bulunamadı');
            setLoading(false);
            return;
          }
        } else {
          console.log('Failed to fetch announcements list');
          setError('Duyurular yüklenirken bir hata oluştu');
          setLoading(false);
          return;
        }
      }

      if (!guid) {
        console.log('No guid available');
        setError('Duyuru bilgisi bulunamadı');
        setLoading(false);
        return;
      }

      console.log('Fetching announcement detail for guid:', guid);
      const response = await getAnnouncementByGuid(guid);
      console.log('Announcement detail response:', response);
      
      if (response.isSuccess && response.data) {
        setAnnouncement(response.data);
        setError(null);
      } else {
        setError(`Duyuru detayı yüklenirken bir hata oluştu: ${JSON.stringify(response)}`);
      }
    } catch (error) {
      console.error('Error in fetchAnnouncementDetail:', error);
      setError(`Duyuru detayı yüklenirken bir hata oluştu: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  }, [urlTag, guidFromState]);

  useEffect(() => {
    fetchAnnouncementDetail();
  }, [fetchAnnouncementDetail]);

  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), 'dd MMMM yyyy', { locale: tr });
    } catch (error) {
      return dateString;
    }
  };

  if (loading) {
    return (
      <div className="announcements-detail-page">
        <div className="container-fluid">
          <div className="loading">Yükleniyor...</div>
        </div>
      </div>
    );
  }

  if (error || !announcement) {
    return (
      <div className="announcements-detail-page">
        <div className="container-fluid">
          <div className="alert alert-danger">{error || 'Duyuru bulunamadı'}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="announcements-detail-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="announcements-detail">
              <div className="announcements-detail-title">
                <h2 id="announcements-header">{announcement.header}</h2>
              </div>

              <div className="announcements-detail-content">
                <div className="announcements-detail-boxes">
                  <div className="announcements-detail-box">
                    <div className="announcements-detail-box-left">
                      <span>Duyuru Konusu</span>
                    </div>
                    <div className="announcements-detail-box-right">
                      <p id="announcements-subject">{announcement.header}</p>
                    </div>
                  </div>
                  <div className="announcements-detail-box">
                    <div className="announcements-detail-box-left">
                      <span>Duyuru Birimi</span>
                    </div>
                    <div className="announcements-detail-box-right">
                      <p id="announcements-department">{announcement.department}</p>
                    </div>
                  </div>
                  {announcement.fileUrl && (
                    <div className="announcements-detail-box file">
                      <div className="announcements-detail-box-left">
                        <span>Doküman URL</span>
                      </div>
                      <div className="announcements-detail-box-right">
                        <p id="announcements-url">
                          <a href={announcement.fileUrl} target="_blank" rel="noopener noreferrer">
                            Duyuru Dosyasını İndir
                          </a>
                        </p>
                      </div>
                    </div>
                  )}
                  {announcement.address && (
                    <div className="announcements-detail-box">
                      <div className="announcements-detail-box-left">
                        <span>Duyuru Adresi</span>
                      </div>
                      <div className="announcements-detail-box-right">
                        <p id="announcements-address">{announcement.address}</p>
                      </div>
                    </div>
                  )}
                  <div className="announcements-detail-box">
                    <div className="announcements-detail-box-left">
                      <span>Duyuru Tarihi</span>
                    </div>
                    <div className="announcements-detail-box-right">
                      <p id="announcements-date">{formatDate(announcement.date)}</p>
                    </div>
                  </div>
                  <div className="announcements-detail-box">
                    <div className="announcements-detail-box-left">
                      <span>Duyuru Metni</span>
                    </div>
                    <div className="announcements-detail-box-right">
                      <p id="announcements-detail" dangerouslySetInnerHTML={{ __html: announcement.detail }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementDetail;
